<template>
  <div>
    <div
      class="w-full bg-white flex z-40 border-b border-gray-12 px-8"
      :class="{ fixed: isFixed }"
      style="height: 56px"
    >
      <div class="flex items-center justify-center">
        <a :href="newNextDomain + '/tx'">
          <img
            src="@/assets/images/LogoSeller.svg"
            alt="PRONIアイミツメンバーズ"
          />
        </a>
      </div>
      <div
        class="w-4"
        :class="{
          'sp-display-none': isSpHideHeader,
        }"
      ></div>
      <ul
        class="flex items-center gap-x-4"
        :class="{
          'sp-display-none': isSpHideHeader,
        }"
      >
        <li>
          <a :href="newNextDomain + '/tx'">
            <div
              class="flex items-center px-2 py-2 hover:bg-slate-50 rounded hover:text-coral-main"
            >
              <div
                class="font-semibold"
                :class="{
                  'text-coral-main': $route.name.includes('Tx'),
                }"
              >
                案件一覧
              </div>
            </div>
          </a>
        </li>
        <li>
          <a :href="newNextDomain + '/introduce-condition'">
            <div
              class="flex items-center px-2 py-2 hover:bg-slate-50 rounded hover:text-coral-main"
            >
              <div class="font-semibold">紹介条件</div>
            </div>
          </a>
        </li>
        <li>
          <router-link
            :to="{ name: 'Top' }"
            class="px-2 py-2 hover:bg-slate-50 rounded hover:text-coral-main"
          >
            <span
              class="font-semibold"
              :class="{
                'text-coral-main': ['Top', 'Company', 'Service'].includes(
                  $route.name
                ),
              }"
              >サービス情報</span
            >
          </router-link>
        </li>
        <li v-if="isIntegration240705 !== 'true'">
          <a :href="newNextDomain + '/invoice-report'">
            <div
              class="flex items-center px-2 py-2 hover:bg-slate-50 rounded hover:text-coral-main"
            >
              <div class="font-semibold">請求額報告</div>
            </div>
          </a>
        </li>
        <li>
          <a :href="newNextDomain + '/billing'">
            <div
              class="flex items-center px-2 py-2 hover:bg-slate-50 rounded hover:text-coral-main"
            >
              <div class="font-semibold">ご利用明細</div>
            </div>
          </a>
        </li>
        <li>
          <a href="https://seller-doc.imitsu-cloud.jp/" target="_blank">
            <div
              class="flex items-center px-2 py-2 hover:bg-slate-50 rounded hover:text-coral-main"
            >
              <div class="font-semibold">ご利用ガイド</div>
            </div>
          </a>
        </li>
      </ul>
      <div
        class="flex-grow"
        :class="{
          'sp-display-none': isSpHideHeader,
        }"
      ></div>
      <div
        class="inline-flex items-center"
        :class="{
          'sp-display-none': isSpHideHeader,
        }"
      >
        <div
          v-if="globalStore.seller.is_buyer_exists"
          class="body-md cursor-pointer px-4 py-2 rounded-full hover:text-gray-92 hover:bg-slate-100 border"
          @click="globalMethods.loginToBuyer()"
        >
          カスタマーマイページ
        </div>
        <div
          v-else
          class="flex items-center font-semibold text-xs cursor-pointer px-6 py-2 rounded-full text-white bg-coral-main leading-5"
          @click="globalMethods.loginToBuyer()"
        >
          <img
            src="@/assets/icons/PlusWhite.svg"
            alt=""
            class="w-4 h-4"
          />カスタマー登録をする
        </div>
      </div>
      <div
        class="w-8"
        :class="{
          'sp-display-none': isSpHideHeader,
        }"
      ></div>
      <div
        class="inline-flex items-center gap-x-3 p-2"
        :class="{
          'sp-display-none': isSpHideHeader,
        }"
      >
        <!--アカウント招待-->
        <div class="w-10 relative cursor-pointer">
          <div
            @click="
              globalStore.modalInvite.isShow = !globalStore.modalInvite.isShow
            "
            class="px-2 py-2 flex justify-center items-center hover:bg-slate-50 rounded"
            @mouseover="globalStore.modalInvite.isHover = true"
            @mouseleave="globalStore.modalInvite.isHover = false"
          >
            <img
              v-if="
                globalStore.modalInvite.isShow ||
                globalStore.modalInvite.isHover
              "
              class="w-6 h-6"
              alt=""
              src="@/assets/icons/AddAccountActived.svg"
            />
            <img
              v-else
              class="w-6 h-6"
              alt=""
              src="@/assets/icons/AddAccount.svg"
            />
          </div>
          <div style="position: absolute; width: 100px; z-index: 18">
            <div
              class="invite-wrapper"
              style="display: inline-block; position: absolute"
              v-show="
                !globalStore.modalInvite.isShow &&
                globalStore.modalInvite.isHover
              "
            >
              <div
                class="annotation-arrow text-white bg-secondary-main py-2 px-4 rounded-lg"
                style="
                  font-size: 13px;
                  line-height: 18px;
                  position: relative;
                  display: block;
                "
              >
                <div>招待</div>
              </div>
            </div>
          </div>
        </div>
        <!--↑アカウント招待↑-->
        <!--↓お知らせ↓-->
        <div class="w-10 relative">
          <div
            class="w-10 cursor-pointer hover:bg-slate-50"
            @mouseover="globalStore.notification.isHover = true"
            @mouseleave="globalStore.notification.isHover = false"
            @click="
              globalStore.notification.isShow = !globalStore.notification.isShow
            "
          >
            <div class="p-2">
              <img
                v-if="
                  globalStore.notification.isShow ||
                  globalStore.notification.isHover ||
                  ['NotificationIndex', 'NotificationDetail'].includes(
                    $route.name
                  )
                "
                class="w-6 h-6"
                alt=""
                src="@/assets/icons/CoralBell.svg"
              />
              <img
                v-else
                class="w-6 h-6"
                alt=""
                src="@/assets/icons/Bell.svg"
              />
            </div>
            <span
              v-if="globalStore.notification.count > 0"
              class="flex justify-center bg-coral-main rounded-full text-white absolute px-1"
              style="top: 0; left: 20px; font-size: 0.6875rem"
            >
              {{
                globalStore.notification.count > 99
                  ? 99
                  : globalStore.notification.count
              }}
            </span>
            <div style="position: absolute; width: 100px; z-index: 18">
              <div
                class="notification-wrapper"
                style="display: inline-block; position: absolute"
                v-show="
                  !globalStore.notification.isShow &&
                  globalStore.notification.isHover
                "
              >
                <div
                  class="annotation-arrow text-white bg-secondary-main py-2 px-4 rounded-lg"
                  style="
                    font-size: 13px;
                    line-height: 18px;
                    position: relative;
                    display: block;
                  "
                >
                  <div>お知らせ</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <NotificationDialog
          v-if="globalStore.notification.isShow"
          @close-notification="globalMethods.closeNotification"
          @read-all-notification="globalStore.notification.count = 0"
        />
        <!--↑お知らせ↑-->
        <!--↓アバター↓-->
        <div
          class="relative cursor-pointer"
          @mouseenter="hoverFlag = true"
          @mouseleave="hoverFlag = false"
        >
          <div class="flex items-center py-1">
            <span
              v-if="globalStore.user.name"
              class="flex text-gray-92 font-semibold text-sm rounded-full p-2 w-8 bg-slate-100 leading-4 justify-center"
              >{{ globalStore.user.name[0] }}</span
            >
          </div>
          <div
            v-show="hoverFlag"
            class="absolute right-0 py-4 bg-white rounded-lg whitespace-no-wrap flex flex-col"
            style="
              box-shadow: 0 0 8px rgba(189, 189, 189, 0.5);
              min-width: 145px;
            "
          >
            <span
              class="block w-full px-4 text-left font-semibold text-gray-92 pb-4 border-b border-gray-12 leading-4"
            >
              {{
                globalStore.user.name && globalStore.user.name.length >= 16
                  ? globalStore.user.name.substr(0, 15) + '...'
                  : globalStore.user.name
              }}
            </span>
            <router-link
              :to="{ name: 'AccountInfo' }"
              class="px-4 py-2 text-gray-92 hover:bg-slate-100 cursor-pointer w-full text-left"
              style="font-size: 0.9375rem"
            >
              アカウント情報
            </router-link>
            <router-link
              :to="{ name: 'AccountPassword' }"
              class="px-4 py-2 text-gray-92 hover:bg-slate-100 cursor-pointer w-full text-left"
              style="font-size: 0.9375rem"
            >
              パスワード変更
            </router-link>
            <router-link
              :to="{ name: 'AccountSettings' }"
              class="px-4 py-2 text-gray-92 hover:bg-slate-100 cursor-pointer w-full text-left"
              style="font-size: 0.9375rem"
            >
              詳細設定
            </router-link>
            <button
              @click="globalMethods.logout()"
              class="px-4 py-2 text-gray-92 hover:bg-slate-100 cursor-pointer w-full text-left"
              style="font-size: 0.9375rem"
            >
              ログアウト
            </button>
          </div>
        </div>
        <!--↑アバター↑-->
      </div>
    </div>
  </div>
</template>
<script>
import { computed, inject, onMounted, reactive, toRefs } from 'vue';
import NotificationDialog from '@/components/NotificationDialog.vue';
import { useRouter } from 'vue-router';
import axios from '@/utils/axiosAuth.js';

export default {
  components: {
    NotificationDialog,
  },

  setup() {
    const globalMethods = inject('globalMethods');
    const globalStore = inject('globalStore');
    const router = useRouter();

    const state = reactive({
      hoverFlag: false,
      transactions: [],
      user: {},
      seller: {},
    });

    const isFixed = computed(() => {
      return router.currentRoute.value.meta.isFixed || '';
    });

    const isSpHideHeader = computed(() => {
      return router.currentRoute.value.meta.isSpHideHeader || false;
    });

    onMounted(async () => {
      axios.get(`/transactions`).then((response) => {
        if (response && response.data && response.data.data) {
          for (const transaction of Object.values(response.data.data)) {
            state.transactions.push(transaction);
          }
        }
      });
    });

    const newNextDomain = process.env.VUE_APP_NEW_NEXT_DOMAIN;
    const isIntegration240705 = process.env.VUE_APP_IS_INTEGRATION_240705;

    return {
      globalMethods,
      globalStore,
      ...toRefs(state),
      isFixed,
      isSpHideHeader,
      newNextDomain,
      isIntegration240705,
    };
  },
};
</script>
<style lang="scss" scoped>
.top-enter-from,
.top-leave-to {
  transform: translateY(-100vh);
}

.top-enter-active,
.top-leave-active {
  transition: transform 0.5s cubic-bezier(0, 0, 0.2, 1) 0ms;
}
.annotation-arrow::after {
  position: absolute;
  content: '';
  display: block;
  width: 10px;
  height: 10px;
  background: #102855;
  transform: rotate(45deg);
}
.notification-wrapper {
  top: 10px;
  .annotation-arrow {
    left: calc(-30%);
    &::after {
      top: -4px;
      left: calc(50% - 2px);
    }
  }
}
.invite-wrapper {
  top: 10px;
  .annotation-arrow {
    left: calc(-19%);
    &::after {
      top: -4px;
      left: calc(50% - 2px);
    }
  }
}
</style>

<style lang="scss" scoped>
@media (max-width: 640px) {
  .sp-display-none {
    display: none;
  }
}
</style>
